<template lang="pug">
u-main
  u-container
    u-page
      u-page-header(
        title="Contact Us"
        description="Reach Unattended Oy for company, legal, privacy, and general inquiries."
      )
      u-page-body
        .flex.flex-col.gap-8.text-sm.text-muted.leading-relaxed
          p.text-base.text-default
            | Unattended Company is operated by Unattended Oy, a company registered in Finland. Use the details below for questions about this website, our products, or matters referenced in our
            |
            u-link(to="/terms") Terms of Service
            |
            | and
            |
            u-link(to="/privacy") Privacy Policy
            | .

          u-button.-mt-2.w-fit(
            href="mailto:frank@unattended.company"
            icon="lucide:mail"
            size="xl"
          ) frank@unattended.company

          section.flex.flex-col.gap-3
            h2.text-lg.font-semibold.text-default Company
            dl(class="grid grid-cols-[auto_1fr] gap-x-6 gap-y-1.5")
              dt.font-semibold.text-default Legal name
              dd Unattended Oy
              dt.font-semibold.text-default Business ID
              dd 3622216-6
              dt.font-semibold.text-default Country
              dd Finland
              dt.font-semibold.text-default Website
              dd
                u-link(
                  href="https://unattended.company"
                  external
                ) unattended.company

          section.flex.flex-col.gap-3
            h2.text-lg.font-semibold.text-default Email
            p
              | For support, privacy requests, legal notices, and other inquiries:
            p
              u-link(href="mailto:frank@unattended.company") frank@unattended.company

          section.flex.flex-col.gap-3
            h2.text-lg.font-semibold.text-default Our products
            p
              | Product-specific questions are often answered faster on each product’s own site.
            p
              | For Kirjaviisas, our curated book club in Finland, visit
              |
              u-link(
                href="https://kirjaviisas.fi"
                target="_blank"
                external
              ) kirjaviisas.fi
              | .
            p
              | For Poemly, visit
              |
              u-link(
                href="https://poemly.app"
                target="_blank"
                external
              ) poemly.app
              |
              | or see the
              |
              u-link(
                href="https://poemly.app/privacy"
                target="_blank"
                external
              ) Poemly Privacy Policy
              |
              | and
              |
              u-link(
                href="https://poemly.app/terms"
                target="_blank"
                external
              ) Poemly Terms of Service
              | .

          section.flex.flex-col.gap-3
            h2.text-lg.font-semibold.text-default Privacy requests
            p
              | To exercise your data protection rights (access, correction, deletion, or objection), email
              |
              u-link(href="mailto:frank@unattended.company") frank@unattended.company
              |
              | with enough detail for us to verify your request. See our
              |
              u-link(to="/privacy") Privacy Policy
              |
              | for more information.
</template>

<script>
export default {
  name: 'PageContact'
}
</script>
